import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form, Button, Card, Container, Row, Col } from "react-bootstrap";

export default function SliderForm() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [buttonUrl, setButtonUrl] = useState("");
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [slideType, setSlideType] = useState("text");
  const [cards, setCards] = useState([
    { title: "", description: "", image: null },
  ]);
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setBackgroundImage(event.target.files[0]);
    }
  };

  const handleCardChange = (index, field, value) => {
    const newCards = [...cards];
    newCards[index] = { ...newCards[index], [field]: value };
    setCards(newCards);
  };

  const addCard = () => {
    if (cards.length < 3) {
      setCards([...cards, { title: "", description: "", image: null }]);
    }
  };

  const removeCard = (index) => {
    const newCards = cards.filter((_, i) => i !== index);
    setCards(newCards);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("button_text", buttonText);
    formData.append("button_link", buttonUrl);
    formData.append("slide_type", slideType);
    if (backgroundImage) {
      formData.append("background_image", backgroundImage);
    }
    if (slideType === "cards") {
      cards.forEach((card, index) => {
        formData.append(`cards[${index}][title]`, card.title);
        formData.append(`cards[${index}][description]`, card.description);
        if (card.image) {
          formData.append(`cards[${index}][image]`, card.image);
        }
      });
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/slider`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 201) {
        alert("Slider created successfully!");
        navigate(0);
      } else {
        alert("Error creating slider.");
      }
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("Error creating slider.");
    }
  };

  return (
    <Container className="my-5">
      <Card>
        <Card.Body>
          <h2 className="mb-4">Create a New Slide</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Background Image</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} required />
            </Form.Group>

            {/* Always show the Slide Title field */}
            <Form.Group className="mb-3">
              <Form.Label>Slide Title</Form.Label>
              <Form.Control
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Slide Title"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Slide Type</Form.Label>
              <Form.Select
                value={slideType}
                onChange={(e) => setSlideType(e.target.value)}
              >
                <option value="text">Text & Button</option>
                <option value="cards">Cards</option>
              </Form.Select>
            </Form.Group>

            {slideType === "text" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Slide Description"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Button Text</Form.Label>
                  <Form.Control
                    value={buttonText}
                    onChange={(e) => setButtonText(e.target.value)}
                    placeholder="Button Text"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Button URL</Form.Label>
                  <Form.Control
                    value={buttonUrl}
                    onChange={(e) => setButtonUrl(e.target.value)}
                    placeholder="Button URL"
                  />
                </Form.Group>
              </>
            )}

            {slideType === "cards" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>Slide Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Slide Description"
                  />
                </Form.Group>

                <h5 className="mt-4">Cards (Max 3)</h5>
                {cards.map((card, index) => (
                  <Card className="my-3" key={index}>
                    <Card.Body>
                      <Form.Group className="mb-2">
                        <Form.Label>Card Title</Form.Label>
                        <Form.Control
                          value={card.title}
                          onChange={(e) =>
                            handleCardChange(index, "title", e.target.value)
                          }
                        />
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label>Card Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          value={card.description}
                          onChange={(e) =>
                            handleCardChange(
                              index,
                              "description",
                              e.target.value,
                            )
                          }
                        />
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label>Card Image</Form.Label>
                        <Form.Control
                          type="file"
                          onChange={(e) =>
                            handleCardChange(
                              index,
                              "image",
                              e.target.files?.[0] || null,
                            )
                          }
                        />
                      </Form.Group>
                      {index > 0 && (
                        <Button
                          variant="danger"
                          onClick={() => removeCard(index)}
                        >
                          Remove
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                ))}
                {cards.length < 3 && (
                  <Button onClick={addCard} variant="secondary">
                    Add Card
                  </Button>
                )}
              </>
            )}

            <Button type="submit" variant="inchworm" className="mt-3">
              Submit
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}
